import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";

import {
  CREATE_CARD_MOVE_FORM,
  SHUTTLE_OFFSHORE_MODAL_ID,
} from "features/planner/planner.constants";

import { deployEmployeeOnSubmit } from "features/planner/planner.actions";

import SimpleFormModal from "app/components/SimpleFormModal";
import { getQualificationsFromState } from "features/planner/planner.selectors";
import DeployOffshoreForm from "features/planner/components/CreateCardMove/DeployOffshoreForm";
import CreateCardMoveTopContent from "features/planner/components/CreateCardMove/CreateCardMoveTopContent";

class ShuttleOffshoreModal extends PureComponent {
  render() {
    const { dispatchOnSubmit } = this.props;

    return (
      <SimpleFormModal
        submitText="Move"
        title="Move to New Location"
        onSubmit={dispatchOnSubmit}
        component={DeployOffshoreForm}
        Tabs={CreateCardMoveTopContent}
        modalId={SHUTTLE_OFFSHORE_MODAL_ID}
        DialogProps={{
          maxWidth: "md",
          fullWidth: true,
        }}
        form={{
          form: CREATE_CARD_MOVE_FORM.ID,
        }}
      />
    );
  }
}

export default compose(
  connect(
    state => ({
      qualifications: getQualificationsFromState(state),
    }),
    {
      dispatchOnSubmit: deployEmployeeOnSubmit,
    },
  ),
)(ShuttleOffshoreModal);
